import { render } from "./pageRace.vue?vue&type=template&id=0223e839&scoped=true"
import script from "./pageRace.vue?vue&type=script&lang=js"
export * from "./pageRace.vue?vue&type=script&lang=js"

import "./pageRace.vue?vue&type=style&index=0&id=0223e839&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0223e839"]])

export default __exports__